import smart_mentor from '../assets/smart_mentor.png';

const AboutSection = ({ variant = 'classic' } = {}) => {
  if (variant === 'v2') {
    return (
      <section id="about" className="relative overflow-hidden bg-[#f8f7fc] py-20 sm:py-28">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_left,rgba(103,86,254,0.08),transparent_55%)]" />
        <div className="relative mx-auto flex max-w-6xl flex-col items-center gap-12 px-4 sm:px-6 lg:flex-row lg:gap-16 lg:px-8">
          <div className="lg:w-1/2">
            <p className="text-xs font-bold tracking-[0.3em] text-[#6756FE] uppercase">Mentors</p>
            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Meet your Mentors
            </h2>
            <p className="mt-5 text-base leading-relaxed text-slate-600">
              Our group mentors have many years of experience in the American options financial markets,
              specializing in Options Scalp Trading Strategies and Time Frames. They will guide you through
              the Ingredients of our Trading Options Setups, Relative Strength Index Demystified, Step Pattern
              Breakout Strategy, Sequencing Strategy, and Momentum Strategy.
            </p>
            <div className="mt-8 grid grid-cols-2 gap-3 sm:gap-4">
              {['Options scalp setups', 'RSI demystified', 'Breakout & sequencing', 'Momentum strategy'].map(
                (item) => (
                  <div
                    key={item}
                    className="rounded-2xl border border-slate-200/80 bg-white px-4 py-3 text-sm font-medium text-slate-700 shadow-sm shadow-slate-200/40"
                  >
                    {item}
                  </div>
                )
              )}
            </div>
          </div>

          <div className="relative flex justify-center lg:w-1/2">
            <div className="absolute -inset-6 rounded-full bg-[#6756FE]/15 blur-3xl" aria-hidden />
            <div className="relative overflow-hidden rounded-3xl border border-slate-200/80 bg-white p-3 shadow-xl shadow-slate-200/50">
              <img
                src={smart_mentor}
                alt="Mentor"
                className="relative z-10 w-72 max-w-full object-contain sm:w-80"
              />
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-[#0e0e11] text-white py-24 px-4 md:px-20">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">
        <div className="lg:w-1/2">
          <h2 className="text-white text-3xl md:text-4xl font-bold mb-6">Meet your Mentors</h2>
          <p className="text-gray-300 leading-relaxed mb-6">
            Our group mentors have many years of experience in the American options financial markets, specializing in Options Scalp Trading Strategies and Time Frames. They will guide you through the Ingredients of our Trading Options Setups, Relative Strength Index Demystified, Step Pattern Breakout Strategy, Sequencing Strategy, and Momentum Strategy.
          </p>
        </div>
        <div className="lg:w-1/2 flex justify-center">
          <div className="relative">
            <img
              src={smart_mentor}
              alt="Mentor"
              className="w-80 max-w-sm lg:max-w-md object-contain z-10 relative"
            />
            <div className="absolute -top-4 -left-4 w-full h-full rounded-full border border-indigo-500 blur-xl opacity-20"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
